<!--
 * @Author: your name
 * @Date: 2021-04-14 15:15:33
 * @LastEditTime: 2021-04-14 15:18:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-henan-oms-facade-SIT\src\views\layout\index.vue
-->
<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'layout'
}
</script>



// WEBPACK FOOTER //
// src/views/layout/index.vue